import type { BasketCard as BasketCardSchema } from "@acto/genui-components-schema";
import { useTranslations } from "@acto/web-common/locales";
import { Card } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { Divider } from "@acto/taskpane/field-sales-2/components/primitives/Divider";
import { CardHeader } from "./CardHeader";
import { ChartSection } from "./ChartSection";
import { KpiPair } from "./KpiPair";
import { OrderScopeEntries } from "./OrderScopeEntries";

export function BasketCard({ part }: { part: BasketCardSchema }) {
  const t = useTranslations("fieldSalesTwo.genuiMeetingPrep.orderCard");

  return (
    <Card nested>
      <CardHeader label={part.label} headline={part.headline} />
      <Divider />
      <KpiPair items={part.kpis} />
      <ChartSection section={part.chart} />
      <Divider />
      <OrderScopeEntries section={part.orders} allOrdersTitle={t("allOrders")} orderListEyebrow={part.label?.text} />
    </Card>
  );
}
